import 'swiper/css';
import 'swiper/css/bundle';
import Swiper from "swiper";
import {
	Navigation,
	Pagination,
	Autoplay,
	EffectFade,
	EffectCoverflow,
	Thumbs,
	EffectCreative,
	Mousewheel,
} from "swiper/modules";
import $ from 'jquery'

import "./index.scss";
import "./js/pages/main";
import "./js/pages/main-d";

import "./js/components/header";
import "./js/components/modal";
import "./js/components/form";
import "./js/components/file";

import { example } from "./js/utils/constants";
import "./js/utils/swiper";
import "./js/utils/map";


